import { createAsyncThunk } from '@reduxjs/toolkit'
import { ServiceConfig } from '../services/config'
import { get, APIError } from '../services/crud'
import { ICampaign } from './typings'
import { ISearchResponse } from '@sales-center/common'

const baseUrl = `${ServiceConfig.baseAPIUrl}${ServiceConfig.coreProduct.campaign}`

export const getCampaigns = createAsyncThunk<
  ICampaign[],
  void,
  { rejectValue: APIError }
>('campaign/get', async (_, thunkApi) => {
  const response = await get(baseUrl)
  if (response.ok) {
    const result: ISearchResponse<ICampaign> = await response.json()
    return result.items
  }
  return thunkApi.rejectWithValue(await response.json())
})
